module.exports = __webpack_public_path__ + "fonts/HelveticaNowMicro-ExtraLight.05fd1068.woff2";